import { InternalStatusCodes } from "../entities/formEvent";
import { mapStatusCodeToStatusText } from "./MapStatusCodeToStatusText";
import { StatusCodeType } from "./GetFormErrorTypes";

export function getStatusCodes(): StatusCodeType[] {
    let result: StatusCodeType[] = [];
    const values = Object.values(InternalStatusCodes);

    function isValidStatus(statusCode: InternalStatusCodes) {
        switch (statusCode) {
            case InternalStatusCodes.CaseCreated:
            case InternalStatusCodes.WaitingDoctor:
            case InternalStatusCodes.ReceivedByDoctor:
            case InternalStatusCodes.DeclinedByDoctor:
            case InternalStatusCodes.ResponseByDoctor:
            case InternalStatusCodes.UnknownError:
                return true;
            default:
                return false;
        }
    }

    for (const value of values) {
        const statusCode = Number(value);

        if (isNaN(statusCode) || !isValidStatus(statusCode)) continue;

        result.push({
            statusCode: String(statusCode),
            displayValue: mapStatusCodeToStatusText(statusCode)
        });
    }
    return result;
}
